<template>
  <footer class="footer" role="contentinfo">
    <div class="container">
      <nav aria-label="web-site footer" role="navigation">
        <ul>
          <li><router-link to="privacy" class="p-0">Privacy</router-link></li>
          <li><router-link to="terms" class="p-0">Terms</router-link></li>
          <!--<li><router-link to="contact" class="p-0">Contact</router-link></li>-->
         <!-- <li><a href="https://bizminer.com/contact/" class="p-0" target="_blank">Contact</a></li>-->
        </ul>
      </nav>
      <div class="copyright text-center">
        Copyright © {{ new Date().getFullYear() }} Bizminer. All Rights Reserved.
      </div>
    </div>
  </footer>
</template>
<script>
import Vuex from 'vuex';

export default {
  name: "content-footer",
  data() {
    return {
      devDate: null,
      userDataLoaded: false,
      subscriptionDataLoaded: false
    };
  },
  computed: {
    ...Vuex.mapState({
      auth_user: (state) => state.user,
      'auth_user.user_subscriptions': (state) => {
        return state.user.user_subscriptions;
      },
    })
  },
  methods: {
    makeRequest: function(url) {
      return new Promise(function(resolve, reject) {
        var xhr = new XMLHttpRequest();
        xhr.open("get", url, true);
        xhr.responseType = "document";
        xhr.onload = function() {
          var status = xhr.status;
          if (status == 200) {
            resolve(xhr);
          } else {
            reject(status);
          }
        };
        xhr.send();
      });
    },
  },
  async mounted() {
    await this.makeRequest("/img/logo-md.png").then((res) => {
      if (res.hasOwnProperty("data") && res.data.error) {
        this.$store.commit("SET_ERROR_BIT", true);
        this.$store.commit(
          "SET_ERROR_INFO",
          "<br>" +
            "Server responded with error = True <br> errorCode: " +
            res.data.errorCode
        );
        throw new Error(
          "<br>" +
            "Server responded with error = True <br> errorCode: " +
            res.data.errorCode
        );
      }
      let deployDate = new Date(
        res.getResponseHeader("Date")
      ).toLocaleDateString();

      let deployTime = new Date(res.getResponseHeader("Date")).toLocaleString(
        "en-US",
        {
          hour: "numeric",
          minute: "numeric",
          hour12: true,
        }
      );

      this.devDate = `Last deployed: ${deployDate} ${deployTime}`;
    });
  },
};

</script>

<style></style>
